import { QueryClient } from '@tanstack/react-query';

import { QUERY_STALE_TIME } from '@/config';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_TIME.reference,
        retry: 2,
        refetchOnWindowFocus: false,
      },
    },
  });
}
